import { UserAvatar } from '~/components/UserAvatar'
import { Pill } from '~/components/component-library/Pill'
import { UserPopover } from '~/components/component-library/UserDisplay/components/UserPopover'
import { userDisplayStyles } from '~/components/component-library/UserDisplay/styles'
import { UserDisplayProps } from '~/components/component-library/UserDisplay/types'
import { useAuthUser } from '~/hooks/useAuthUser'
import { cn } from '~/utils/tailwind-utils'

export type {
  UserDisplayProps,
  UserDisplayUser,
} from '~/components/component-library/UserDisplay/types'

export const UserDisplay = ({
  user,
  hidePopover = false,
  layout,
  size,
}: UserDisplayProps) => {
  const { user: authUser } = useAuthUser()
  const isCurrentUser = !!authUser && user.id === authUser.id

  let content

  switch (layout) {
    case 'standard':
      content = (
        <div className={cn(userDisplayStyles({ layout, size }))}>
          <UserAvatar user={user} size={size === 'base' ? 24 : 20} />
          <span className="min-w-0 truncate">
            {user.displayName ?? user.email}
          </span>
          {isCurrentUser && (
            <span className="shrink-0">
              <Pill label="You" size={size} />
            </span>
          )}
        </div>
      )
      break
    case 'inline-text':
      content = (
        <span className={cn(userDisplayStyles({ layout, size }))}>
          {user.displayName ?? user.email}
        </span>
      )
      break
  }

  if (hidePopover) return content

  return (
    <UserPopover align="start" user={user}>
      {content}
    </UserPopover>
  )
}
